import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { CreateUser } from '../../models/user';

@Injectable({ providedIn: 'root' })
export class UserService {
  valueChange = new Subject<any>();
  componentUpdate = new Subject<any>();
  recordsUpdate = new Subject<any>();

  constructor(
    private httpService: HttpService
  ) {
  }

  getUsers(query: Record<string, any>): Observable<any> {
    return this.httpService.getData(APIS.USERS, query);
  }

  createUser(data: CreateUser): Observable<any> {
    return this.httpService.postData(APIS.USERS, data);
  }

  updateUser(userId: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.USERS}/${userId}`, data);
  }

  deleteUser(userId: string): Observable<any> {
    return this.httpService.deleteData(`${APIS.USERS}/${userId}`);
  }
}
